import { Component, OnInit } from '@angular/core';
import { SnotifyService } from 'ng-snotify';
import { RelatorioService } from "./../services/relatorio/relatorio.service";
import { FormBuilder, FormControl, FormGroup } from "@angular/forms";

@Component({
  selector: 'app-relatorio-mapeamento-por-cidades',
  templateUrl: './relatorio-mapeamento-por-cidades.component.html',
  styleUrls: ['./relatorio-mapeamento-por-cidades.component.scss']
})
export class RelatorioMapeamentoPorCidadesComponent implements OnInit {

  public loading = true;

  public listaCidades:Array<any> = [];

  public lastResponse: any = null

  public perPage:number = 10

  public currentPage:number = 1

  public filter: FormGroup = this.fb.group({
    municipio: new FormControl('', []),
    ibge: new FormControl('', []),
    estados: new FormControl('', []),
  });

  public totalMapeamentos:number = 0

  public dropdownSettingsEstados = {
    singleSelection: false,
    idField: 'nome',
    textField: 'descricao',
    itemsShowLimit: 8,
    selectAllText: 'Marcar todas',
    unSelectAllText: 'Desmarcar todas',
    allowSearchFilter: true
  };

  public estados: Array<any> = [
    { nome:'Acre', descricao: "AC | ACRE",},
    { nome:'Alagoas', descricao: "AL | ALAGOAS",},
    { nome:'Amapá', descricao: "AP | AMAPÁ",},
    { nome:'Amazonas', descricao: "AM | AMAZONAS",},
    { nome:'Bahia', descricao: "BA | BAHIA",},
    { nome:'Ceará', descricao: "CE | CEARÁ",},
    { nome:'Distrito Federal', descricao: "DF | DISTRITO FEDERAL",},
    { nome:'Espírito Santo', descricao: "ES | ESPÍRITO SANTO",},
    { nome:'Goiás', descricao: "GO | GOIÁS",},
    { nome:'Maranhão', descricao: "MA | MARANHÃO",},
    { nome:'Mato Grosso', descricao: "MT | MATO GROSSO",},
    { nome:'Mato Grosso do Sul', descricao: "MS | MATO GROSSO DO SUL",},
    { nome:'Minas Gerais', descricao: "MG | MINAS GERAIS",},
    { nome:'Pará', descricao: "PA | PARÁ",},
    { nome:'Paraíba', descricao: "PB | PARAÍBA",},
    { nome:'Paraná', descricao: "PR | PARANÁ",},
    { nome:'Pernambuco', descricao: "PE | PERNAMBUCO",},
    { nome:'Piauí', descricao: "PI | PIAUÍ",},
    { nome:'Rio de Janeiro', descricao: "RJ | RIO DE JANEIRO",},
    { nome:'Rio Grande do Norte', descricao: "RN | RIO GRANDE DO NORTE",},
    { nome:'Rio Grande do Sul', descricao: "RS | RIO GRANDE DO SUL",},
    { nome:'Rondônia', descricao: "RO | RONDÔNIA",},
    { nome:'Roraima', descricao: "RR | RORAIMA",},
    { nome:'Santa Catarina', descricao: "SC | SANTA CATARINA",},
    { nome:'São Paulo', descricao: "SP | SÃO PAULO",},
    { nome:'Sergipe', descricao: "SE | SERGIPE",},
    { nome:'Tocantins', descricao: "TO | TOCANTINS",}
  ];

  constructor(
      private _notify: SnotifyService,
      private relatorioService: RelatorioService,
      private fb: FormBuilder
  )  { 
  }

  ngOnInit() { 
    this.loadTotalMapeamentos();
    this.loadData();
  }

  public loadData() {
    this.loading = true;
    this.relatorioService.listarMapeamentosPorMunicipio(this.getFilters(), this.currentPage, this.perPage).subscribe(
        ({data}:any) => {
            this.loading = false
            this.lastResponse = data;
            this.listaCidades = this.listaCidades.concat(this.lastResponse.cidades.data)
        },
        error => {
            this.loading = false
            this._notify.error("Ocorreu um erro ao carregar os dados")
        }
    )
  }

  public loadTotalMapeamentos() {
    this.relatorioService.totalMapeamentosRealizados().subscribe(
      ({data}:any) => {
        this.totalMapeamentos = data;
      }
    )
  }

  public loadPerPage($event) {
      this.perPage = $event.target.value
      this.reset(false)
      this.loadData()
  }

  public reset(reload: boolean): void {
      this.listaCidades = []
      this.currentPage = 1

      if(reload) {
        Object.keys(this.filter.controls).forEach(key => {
          this.filter.controls[key].setValue(null);
        });

        this.loadData();      
      }
  }

  public loadMore():void {
      this.currentPage++;
      this.loadData()
  }

  public toFilter() {
    this.reset(false);
    this.loadData();
  }

  public getFilters() {
    const filter = {};

    Object.keys(this.filter.controls).forEach((_filter) => {
      filter[_filter] = this.filter.controls[_filter].value;
    });

    if (filter['estados']) {
      filter['estados'] = filter['estados'].map(estados => {
          return estados.nome;
      });
    }

    return filter;
  }

}
